import { render, staticRenderFns } from "./SAMLLogout.vue?vue&type=template&id=6157730a"
import script from "./SAMLLogout.vue?vue&type=script&lang=ts"
export * from "./SAMLLogout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports